import { render, staticRenderFns } from "./SupportDetail.vue?vue&type=template&id=991b7442"
import script from "./SupportDetail.vue?vue&type=script&lang=js"
export * from "./SupportDetail.vue?vue&type=script&lang=js"
import style0 from "./SupportDetail.vue?vue&type=style&index=0&id=991b7442&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports